import { Link } from "react-router-dom";
import { Check } from "lucide-react";

const TIERS = [
  {
    name: "Starter",
    blurb: "Small contractors",
    features: [
      "Ticket management & import",
      "Basic dispatch & assignment",
      "Mobile field app",
      "Standard reporting",
      "Email support",
    ],
  },
  {
    name: "Operations",
    blurb: "Growing teams",
    popular: true,
    features: [
      "Everything in Starter",
      "Smart dispatch & routing",
      "Custom fields & workflows",
      "SLA & compliance alerts",
      "Supervisor QA review",
      "Payroll & production reporting",
    ],
  },
  {
    name: "Enterprise",
    blurb: "Multi-market",
    features: [
      "Everything in Operations",
      "AI ticket prioritization & risk scoring",
      "AI assistant & auto-flagging",
      "Advanced integrations & API",
      "Multi-company & multi-market",
      "Custom reporting & dashboards",
      "Dedicated support & onboarding",
    ],
  },
];

export default function Pricing() {
  return (
    <section data-testid="pricing-section" className="section-y relative">
      <div className="container-x">
        <div className="max-w-3xl reveal mb-12">
          <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#F97316] mb-3">Pricing</div>
          <h2 className="font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight">
            Simple, scalable pricing for every operation size.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {TIERS.map((t, i) => (
            <div
              key={t.name}
              data-testid={`pricing-tier-${t.name.toLowerCase()}`}
              className={`reveal relative rounded-2xl p-7 transition-all ${
                t.popular
                  ? "bg-gradient-to-b from-[#171717] to-[#0a0a0a] border-2 border-[#F97316] shadow-[0_30px_80px_-20px_rgba(249,115,22,0.4)] md:-translate-y-3"
                  : "glass border border-white/10 hover:-translate-y-1 hover:border-white/20"
              }`}
              style={{ transitionDelay: `${i * 60}ms` }}
            >
              {t.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 rounded-full bg-[#F97316] text-white text-xs font-bold font-mono uppercase tracking-widest">
                  Most Popular
                </div>
              )}
              <div className="font-display font-bold text-2xl text-white">{t.name}</div>
              <div className="text-sm text-[#94A3B8] mt-1">{t.blurb}</div>

              <div className="mt-6 mb-6">
                <div className="font-display font-extrabold text-4xl text-white">
                  Custom
                </div>
                <div className="text-xs text-[#94A3B8] mt-1 font-mono uppercase tracking-wider">
                  Quoted by team size & markets
                </div>
              </div>

              <ul className="space-y-2.5 mb-7">
                {t.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm text-white/90">
                    <Check size={16} className={t.popular ? "text-[#F97316] mt-0.5 shrink-0" : "text-[#22C55E] mt-0.5 shrink-0"} />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>

              <Link
                to="/demo"
                data-testid={`pricing-cta-${t.name.toLowerCase()}`}
                className={`w-full inline-flex items-center justify-center font-semibold py-3 rounded-lg transition-all ${
                  t.popular
                    ? "bg-[#F97316] hover:bg-[#ea580c] text-white"
                    : "bg-white/5 hover:bg-white/10 text-white border border-white/10"
                }`}
              >
                Request Pricing
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
